module.exports = __webpack_public_path__ + "img/icn_driver-white.cd7b54d6.svg";